import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MessageSquareText } from "lucide-react";
import { ProductPlaceholder } from "@/components/site/ProductPlaceholder";
import { EnquiryDialog } from "@/components/site/EnquiryDialog";
import { trackEvent } from "@/lib/analytics";

export const ProductCard = ({ product, headingLevel = "h3", ctaLabel = "View Product" }) => {
  const [open, setOpen] = useState(false);
  const H = headingLevel;
  return (
    <article className="card-soft card-hover group flex h-full flex-col overflow-hidden p-3" data-testid={`product-card-${product.slug}`}>
      <Link to={product.path} className="block overflow-hidden rounded-xl" tabIndex={-1} aria-hidden="true">
        <div className="img-zoom">
          <ProductPlaceholder product={product} />
        </div>
      </Link>
      <div className="flex flex-1 flex-col px-2 pb-2 pt-5">
        <div className="mb-2 flex items-center gap-2">
          <span className="badge-info">{product.category}</span>
          {product.featured ? <span className="badge-featured">Featured</span> : null}
        </div>
        <H className="text-xl font-semibold leading-snug">
          <Link to={product.path} className="hover:text-[color:var(--u-green)]">
            {product.fullName || product.name}
          </Link>
        </H>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-muted-foreground">{product.shortDescription}</p>
        <p className="mt-3 text-xs font-medium text-[color:var(--u-brown-dark)]">Price on request</p>
        <div className="mt-4 grid grid-cols-2 gap-2">
          <Link to={product.path} className="btn btn-primary px-3" data-testid={`product-card-view-${product.slug}`}>
            {ctaLabel}
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
          <button
            type="button"
            className="btn btn-outline px-3"
            onClick={() => {
              setOpen(true);
              trackEvent("product_enquiry_click", { product: product.slug, location: "card" });
            }}
            data-testid={`product-card-enquire-${product.slug}`}
            aria-label={`Enquire about ${product.name}`}
          >
            <MessageSquareText className="h-4 w-4" aria-hidden="true" />
            Enquire
          </button>
        </div>
      </div>
      <EnquiryDialog open={open} onOpenChange={setOpen} product={product} />
    </article>
  );
};
